import { FC } from 'react';

import { useFormikContext } from 'formik';
import { Input } from 'ui/components';
import { SIZE } from 'utils/constants';
import { cn } from 'utils/helpers';

import { LEAD_FORM } from './schema';

const LeadAddressForm: FC = () => {
  const { values, touched, errors, handleChange, handleBlur, isSubmitting } =
    useFormikContext<LEAD_FORM>();

  return (
    <div className={cn('grid grid-cols-2 gap-x-6 gap-y-7', 'pt-7')}>
      <Input
        className="w-full"
        type="text"
        name="streetAddress1"
        size={SIZE.Medium}
        textType={
          errors.streetAddress1 && touched.streetAddress1 ? 'danger' : 'default'
        }
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.streetAddress1}
        placeholder="Street Address 1"
        subText={
          errors.streetAddress1 && touched.streetAddress1
            ? errors.streetAddress1
            : undefined
        }
        label="Street Address 1"
        disabled={isSubmitting}
      />
      <Input
        className="w-full"
        type="text"
        name="streetAddress2"
        size={SIZE.Medium}
        textType={
          errors.streetAddress2 && touched.streetAddress2 ? 'danger' : 'default'
        }
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.streetAddress2}
        placeholder="Street Address 2"
        subText={
          errors.streetAddress2 && touched.streetAddress2
            ? errors.streetAddress2
            : undefined
        }
        label="Street Address 2"
        disabled={isSubmitting}
      />
      <Input
        className="w-full"
        type="text"
        name="city"
        size={SIZE.Medium}
        textType={errors.city && touched.city ? 'danger' : 'default'}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.city}
        placeholder="City"
        subText={errors.city && touched.city ? errors.city : undefined}
        label="City"
        disabled={isSubmitting}
      />
      <Input
        className="w-full"
        type="text"
        name="state"
        size={SIZE.Medium}
        textType={errors.state && touched.state ? 'danger' : 'default'}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.state}
        placeholder="State"
        subText={errors.state && touched.state ? errors.state : undefined}
        label="State"
        disabled={isSubmitting}
      />
      <Input
        className="w-full"
        type="text"
        name="zipcode"
        size={SIZE.Medium}
        textType={errors.zipcode && touched.zipcode ? 'danger' : 'default'}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.zipcode}
        placeholder="Zip/Postal Code"
        subText={errors.zipcode && touched.zipcode ? errors.zipcode : undefined}
        label="Zip/Postal Code"
        disabled={isSubmitting}
      />
      <Input
        className="w-full"
        type="text"
        name="country"
        size={SIZE.Medium}
        textType={errors.country && touched.country ? 'danger' : 'default'}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.country}
        placeholder="Country"
        subText={errors.country && touched.country ? errors.country : undefined}
        label="Country"
        disabled={isSubmitting}
      />
    </div>
  );
};

export default LeadAddressForm;
